<ng-container *transloco="let t">
  <div class="owner-statement">
    <div [formGroup]="form">
      <h3 class="mb-2">
        {{
          t('Owner Statement Regarding Vaccination Against Infectious Diseases')
        }}
      </h3>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Number of males:') }}</mat-label>
        <input matInput formControlName="numMales" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Number of females:') }}</mat-label>
        <input matInput formControlName="numFemales" />
      </mat-form-field>

      <h3 class="mt-2 mb-1">{{ t('Note') }}</h3>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('Note') }}</mat-label>
        <textarea matInput formControlName="note" rows="4"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('veterinarianName') }}</mat-label>
        <input matInput formControlName="veterinarianName" />
        <mat-error>{{ t('This field is required') }}</mat-error>
      </mat-form-field>
    </div>
  </div>
</ng-container>
